import styles from "./index.module.scss"

export const NoDataLayer = () => {
  return (
    <div className={styles.emptyReportDataContainer}>
      <div>No data</div>
    </div>
  )
}
